import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  install: (app) => {
    gsap.registerPlugin(ScrollTrigger);
    app.config.globalProperties.$gsap = gsap;
    app.provide('gsap', gsap);
  },
};
